import { Component } from '@angular/core';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { Subscription } from 'rxjs';
//SERVICE
import { DemographicService } from "../../services/demographics.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BroadcastPreview } from '../broadcastpreview.service';
import { lang_idiomas } from 'app/idiomas/i18n/idiomas/idiomas.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';


@Component({
    selector     : 'demo-preview',
    templateUrl  : './demopreview.component.html',
    styleUrls    : ['./demopreview.component.scss']
})
export class DemoPreviewComponent {
    idiomasArray: any;
    questions: any = [];
    subscription: Subscription;


  constructor(
      public snackBar: MatSnackBar,
      private demographicService: DemographicService,
      public _fuseTranslationLoaderService: FuseTranslationLoaderService,
      private broadcast: BroadcastPreview
      ) {
        lang_idiomas.forEach((locale) => {
          this._fuseTranslationLoaderService.loadTranslations(locale);
        });


        this.subscription = this.broadcast.getEvent().subscribe(product => {
           //6console.log('ENTRANDO de preview...');
           this.getLanguajesList();

         });

         this.getLanguajesList();


  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.questions, event.previousIndex, event.currentIndex);

    this.updateOrden();

  }


  onDrop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex);
    }
  }

  public getLanguajesList(){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto')
    }
      this.demographicService.getLanguajesListNon3(data)
      .subscribe(response => {
        let res = [];
        this.idiomasArray = response['idiomasMostrar'];

      }, error => {
        console.log("error", error);
      })
  }

  public changeIdioma(event){
    //this.nombreIdioma = event.value.nombreIdioma;
    console.log(event.value.tipoIdioma);
    if(event.value.tipoIdioma == 1){
      this.obtienePreviewNativo(event.value._id);
    }else{
      this.obtienePreview(event.value._id);
    }
  }

  public obtienePreviewNativo(idIdioma){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto'),
      idiomaId: idIdioma
    }
    this.demographicService.getPreview(data)
    .subscribe(response => {
      console.log(response);
      let result = [];

      for (let i = 0; i < response['objetoRespuesta']['demograficos'].length; i++) {
        let arrayOpciones = [];
        for (let j = 0; j < response['objetoRespuesta']['demograficos'][i]['opciones'].length; j++) {
            let objetoOpciones = {
              ordenOpcion: response['objetoRespuesta']['demograficos'][i]['opciones'][j]['ordenOpcion'],
              traduccionOpcion: response['objetoRespuesta']['demograficos'][i]['opciones'][j]['textoOpcion']
            }
            arrayOpciones.push(objetoOpciones);
        }
        let objeto = {
          demograficoId: response['objetoRespuesta']['demograficos'][i]['demograficoId'],
          preguntaTraduccion: response['objetoRespuesta']['demograficos'][i]['preguntaNativa'],
          opciones: arrayOpciones
        }
        result.push(objeto);
      }

      this.questions = result;

    }, error => {
      console.log("error", error);
    })

  }

  public obtienePreview(idIdioma){
    let data = {
      fechaCertificar: localStorage.getItem('fechaProducto'),
      idiomaId: idIdioma
    }
    this.demographicService.getPreview(data)
    .subscribe(response => {

      let flag = true;
      let resArray = [];
      //this.questions = response['objetoRespuesta']['demograficos'];
      for (let i = 0; i < response['objetoRespuesta']['demograficos'].length; i++) {
        //console.log(response['objetoRespuesta']['demograficos'][i]);
        if(response['objetoRespuesta']['demograficos'][i]['preguntaTraduccion'].length > 0){
            for (let j = 0; j < response['objetoRespuesta']['demograficos'][i]['opciones'].length; j++) {
              if(response['objetoRespuesta']['demograficos'][i]['opciones'][j]['traduccionOpcion'].length > 0){
                  flag = true;
              }else{
                  flag = false;
                  break;
              }
            }
        }else{
          flag = false;
        }
        //console.log(flag);
        if(flag){
          resArray.push(response['objetoRespuesta']['demograficos'][i]);
        }
      }

      this.questions = resArray;

    }, error => {
      console.log("error", error);
    })

  }

  public updateOrden(){

    for (let i = 0; i < this.questions.length; i++) {

      let data = {
        fechaCertificar: localStorage.getItem('fechaProducto'),
        demograficoId: this.questions[i]['demograficoId'],
        ordenDemografico: (i+1)
      }

      this.demographicService.updateDemographicData(data)
        .subscribe(response => {
          console.log(response);

        }, error => {
          console.log("error", error);
        });

    }
  }

}

/*
fechaCertificar:localStorage.getItem('fechaProducto')
demograficoId:5d8d6bfb9dba352710d36b47
preguntaDemografico:nuevo demo 2
ordenDemografico:1
opcionId:5d8d6bfc9dba352710d36b64
textoOpcion:nuevo texto 2
ordenOpcion:1
*/
